/* Copyright (c) 2026 PearlCrm Pty Ltd. All rights reserved. */

/**
 * Root domain for tenant + app hosts.
 * Local default matches Auth.js / .env.example (*.pearlcrm.localhost).
 */
export const getBaseDomain = () => {
  const isProd = process.env.NODE_ENV === 'production';
  const fallback = isProd ? 'localhost' : 'pearlcrm.localhost';
  const host = (process.env.REACT_APP_FRONTEND || fallback).trim().replace(/\/$/, '');
  return host.startsWith('app.') ? host.slice(4) : host;
};

export const buildTenantDashboardUrl = (schema) => {
  const tenant = schema?.startsWith('tenant_') ? schema.slice('tenant_'.length) : schema;
  const isProd = process.env.NODE_ENV === 'production';
  const protocol = isProd ? 'https://' : 'http://';
  const port = !isProd && window.location.port ? `:${window.location.port}` : '';
  return `${protocol}${tenant}.${getBaseDomain()}${port}/dashboard`;
};

/** Central login on the main app host (never a tenant subdomain). */
export const SIGNED_OUT_PARAM = 'signed_out';

export const buildAppLoginUrl = ({ signedOut = false } = {}) => {
  const isProd = process.env.NODE_ENV === 'production';
  const protocol = isProd ? 'https://' : 'http://';
  const port = !isProd && window.location.port ? `:${window.location.port}` : '';
  const query = signedOut ? `?${SIGNED_OUT_PARAM}=1` : '';
  return `${protocol}app.${getBaseDomain()}${port}/auth/login${query}`;
};

/**
 * True (and strips the flag from the address bar) when this page load is the
 * landing after a sign-out. The app host then drops any token it still holds
 * instead of signing the user straight back into their workspace.
 */
export const consumeSignedOutFlag = (win = window) => {
  try {
    const url = new URL(win.location.href);
    if (url.searchParams.get(SIGNED_OUT_PARAM) !== '1') return false;
    url.searchParams.delete(SIGNED_OUT_PARAM);
    win.history.replaceState(win.history.state, '', `${url.pathname}${url.search}${url.hash}`);
    return true;
  } catch (e) {
    return false;
  }
};
